import "@babel/polyfill"; //(一定要在最上面，第一行)
import Es6Promise from "es6-promise";
require("es6-promise").polyfill();
Es6Promise.polyfill();
import { createApp, nextTick } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
// require('ant-design-vue/dist/antd.css')
import 'ant-design-vue/dist/antd.css'
import '@/assets/common.less'

import { Md5 } from 'ts-md5'
import directive from '@/utils/directive'
import globalsets from './utils/globalsets'
// router.beforeEach((to, from, next) => {

//   next()
// })
import moment from 'moment'
import './utils/flat.js'

window.moment = moment
window.Md5 = Md5
// let $favicon = document.querySelector('link[rel="icon"]')

// 路由拦截
router.beforeEach((to, from, next) => {
  const favicon: any = document.querySelector('link[rel="icon"]')
  favicon.href = './favicon.ico'
  if (to.name === 'f10laout') {
    favicon.href = './faviconjf.png'
    document.title = 'F10资料'
  }
  next()
})

export default router
const app = createApp(App)
app.use(store).use(router).use(Antd).use(directive).mount('#app')

/*
app.config.globalProperties.$moment = moment
app.config.globalProperties.$globalsets = globalsets

// 挂载全局，但需要用getCurrentInstance 方法获取
// import { getCurrentInstance } from 'vue'
// const { proxy } = getCurrentInstance()
// 使用
// proxy.$moment
// proxy.$globalsets

*/
